/* =============================================================================
   ASP — Black Friday Residential Quiz
   assets/bf-residential-quiz.js

   Separate from the commercial Acoustic Assessment. Eligibility comes from the
   Black Friday collection at runtime; prices, variants, images and availability
   are read live from Shopify. The table below holds only what Shopify does not
   expose: coverage per pack, units per pack, look and role.

   Replace this table with product metafields when ASP creates them.
   ========================================================================== */

(function () {
  'use strict';

  var ATTRS = {
"peel-stick-pinnable-tiles":        {"cov":2.16,"units":6,"noun":"tiles","look":"flat","role":"workhorse","group":"composition","sp":["office","living","bedroom","kids","media","music","other"]},
"peel-n-stick-pinnable-acoustic-tiles-bulk-pack": {"cov":12.96,"units":36,"noun":"tiles","look":"flat","role":"workhorse","group":"composition","sp":["office","living","bedroom","kids","media","music","other"]},
"honeycomb-acoustic-tiles":         {"cov":2.34,"units":40,"noun":"tiles","look":"geometric","role":"workhorse","group":"cube","sp":["office","living","kids","music","other"]},
"groove-wall-tiles":                {"cov":2.88,"units":8,"noun":"tiles","look":"texture","role":"workhorse","group":"groove","sp":["office","living","media","music","other"]},
"acoufelt-quietform-tiles-kalos":   {"cov":2.88,"units":8,"noun":"tiles","look":"texture","role":"workhorse","group":"quietform","design":"Kalos","sp":["office","living","media","music","other"]},
"acoufelt-quietform-tiles-pole":    {"cov":2.88,"units":8,"noun":"tiles","look":"texture","role":"workhorse","group":"quietform","design":"Pole","sp":["office","living","media","music","other"]},
"acoufelt-quietform-tiles-flute":   {"cov":2.88,"units":8,"noun":"tiles","look":"texture","role":"workhorse","group":"quietform","design":"Flute","sp":["office","living","media","music","other"]},
"acoufelt-quietform-tiles-celestial":{"cov":2.88,"units":8,"noun":"tiles","look":"texture","role":"workhorse","group":"quietform","design":"Celestial","sp":["office","living","media","music","other"]},
"acoufelt-fracture-acoustic-tiles": {"cov":3.24,"units":18,"noun":"tiles","look":"texture","role":"workhorse","group":"fracture","sp":["office","living","media","music","kids","other"]},
"acoustek-newport-collection":      {"cov":2.25,"units":9,"noun":"tiles","look":"geometric","role":"workhorse","group":"newport","sp":["living","bedroom","office","media","other"]},
"acoustek-cavasinni-collection-acoustic-wall-tiles": {"cov":2.25,"units":9,"noun":"tiles","look":"geometric","role":"workhorse","group":"cavasinni","sp":["living","bedroom","office","media","other"]},
"woodbequiet-acoustic-wall-planks": {"cov":4.50,"units":15,"noun":"planks","look":"timber","role":"workhorse","group":"woodbequiet","sp":["living","office","media","bedroom","other"]},
"acoustek-wallflower-3d-acoustic-tiles": {"cov":0.64,"units":4,"noun":"panels","look":"feature","role":"feature","group":"wallflower","sp":["living","bedroom","kids","other"]},
"acoustek-clover-3d-acoustic-tiles":{"cov":0.64,"units":4,"noun":"panels","look":"feature","role":"feature","group":"clover","sp":["living","bedroom","kids","other"]}
}
;
  var VERSION = '1.0.0';

  /* --- Questions ---------------------------------------------------------- */
  var QUESTIONS = [
    { id: 'room', type: 'single',
      title: 'Which room are you improving?',
      options: [
        { v: 'office',  label: 'Home office or study' },
        { v: 'living',  label: 'Living room or open-plan living' },
        { v: 'media',   label: 'Home theatre or media room' },
        { v: 'bedroom', label: 'Bedroom' },
        { v: 'kids',    label: "Kids' room or playroom" },
        { v: 'music',   label: 'Music or gaming room' },
        { v: 'other',   label: 'Somewhere else in the home' }
      ] },

    { id: 'goal', type: 'single',
      title: 'What are you trying to fix?',
      help: 'Pick whichever is closest. If it is more than one, say so.',
      options: [
        { v: 'echo',      label: 'Echo. The room sounds harsh or boomy' },
        { v: 'speech',    label: 'Voices and video calls are hard to follow' },
        { v: 'listening', label: "TV, films or music don't sound as good as they should" },
        { v: 'looks',     label: 'I want it to look good as much as sound good' },
        { v: 'transfer',  label: 'Noise coming in from outside or another room', interstitial: true },
        { v: 'unsure',    label: "Not sure, I just know it doesn't sound right" }
      ] },

    { id: 'size', type: 'dims',
      title: 'How big is the room?',
      help: 'Rough measurements are fine. If the room is open-plan, measure the part you actually want to treat.' },

    { id: 'height', type: 'single',
      title: 'How high are the ceilings?',
      options: [
        { v: 2.4, label: 'Standard, about 2.4 m' },
        { v: 2.7, label: 'High, about 2.7 m' },
        { v: 3.2, label: 'Very high or raked, 3 m or more' }
      ],
      showIf: function (a) { return a.areaMode !== 'known'; } },

    { id: 'coverage', type: 'single',
      title: 'How much treatment do you want?',
      help: 'This sets how much of the wall gets covered, so it decides how many packs you need. You can change it on the results page.',
      options: [
        { v: 0.20, label: 'Light. Takes the edge off. Covers about a fifth of the wall' },
        { v: 0.25, label: 'Balanced. Noticeably calmer. Covers about a quarter' },
        { v: 0.50, label: 'Full. For media and music rooms. Covers about half' }
      ] },

    { id: 'look', type: 'single',
      title: 'What look do you want?',
      help: 'All of these absorb sound. This is about how the wall looks.',
      options: [
        { v: 'any',       label: 'No preference, show me what works best' },
        { v: 'flat',      label: 'Flat and understated' },
        { v: 'texture',   label: 'Textured or three-dimensional' },
        { v: 'timber',    label: 'Timber look' },
        { v: 'geometric', label: 'Geometric or patterned' },
        { v: 'feature',   label: 'A feature piece, not a whole wall' }
      ] }
  ];

  /* Product-family names. The card is headed by the family, because the pack
     mix inside it is chosen by the optimiser and may not be the lead pack. */
  var GROUP_LABEL = {
    composition: 'Composition Peel n Stick Acoustic Tiles',
    cube: 'Cube Honeycomb Acoustic Tiles',
    groove: 'Groove Wall Tiles',
    quietform: 'QuietForm 3D Acoustic Tiles',
    fracture: 'Acoufelt Fracture Wall Panels',
    newport: 'Newport Collection Wall Tiles',
    cavasinni: 'Cavasinni Collection Wall Tiles',
    woodbequiet: 'WoodBeQuiet Acoustic Wall Planks',
    wallflower: 'WallFlower 3D Acoustic Panels',
    clover: 'Clover 3D Acoustic Wall Panels'
  };

  var ROOM_LABEL = { office: 'home office', living: 'living room', media: 'media room',
    bedroom: 'bedroom', kids: "kids' room", music: 'music room', other: 'room' };

  var COVER_LABEL = function (r) {
    return r <= 0.20 ? 'Light' : (r >= 0.50 ? 'Full' : 'Balanced');
  };

  var WHY = {
    flat: 'Flat fabric tiles are the most straightforward thing to put on a wall and the cheapest way to cover real area. They cut and fit around switches and skirting without fuss.',
    texture: 'The three-dimensional face gives you a wall that reads as deliberate rather than treated, while doing the acoustic work.',
    timber: 'Timber-look planks warm the room up and read as joinery rather than acoustic panelling.',
    geometric: 'The pattern makes this a design decision as much as an acoustic one, which suits a room people actually sit in.',
    feature: 'These are feature pieces. A cluster behind a desk or above a sofa, not a whole wall.'
  };

  var ROOM_WHY = {
    office: 'In a home office the problem is almost always voices bouncing off a hard wall behind the desk, so that wall is where to start.',
    living: 'Open-plan living rooms are hard surfaces in every direction, so even partial coverage on one or two walls changes how the space feels.',
    media: 'In a media room the first reflection points either side of the screen matter most, which is where to concentrate the coverage.',
    bedroom: 'Bedrooms are usually softer already thanks to the bed and curtains, so a lighter treatment goes a long way.',
    kids: "Kids' rooms get loud and get knocked about, so something durable and pinnable earns its place.",
    music: 'A room you play or record in needs real coverage, not a few panels, which is why the full option exists.',
    other: ''
  };

  /* --- Analytics ---------------------------------------------------------- */
  var attemptId = null;
  function newAttempt() {
    attemptId = 'a' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    return attemptId;
  }
  function track(name, params) {
    var payload = Object.assign({
      event: name,
      quiz_id: 'bf_residential_2026',
      quiz_version: VERSION,
      attempt_id: attemptId
    }, params || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) { /* never break the quiz for analytics */ }
  }
  function sizeBand(m2) {
    if (m2 == null) return 'unknown';
    if (m2 < 12) return 'under_12';
    if (m2 < 20) return '12_20';
    if (m2 < 35) return '20_35';
    if (m2 < 60) return '35_60';
    return 'over_60';
  }

  /* --- Area maths. Four quantities, never interchanged. ------------------- */
  function areas(a) {
    if (a.areaMode === 'known') {
      return { floor: null, wall: null, treatment: a.panelArea || null, known: true };
    }
    var L = a.length, W = a.width, H = a.height || 2.4;
    if (!L || !W) return { floor: null, wall: null, treatment: null, known: false };
    var floor = L * W;
    var wall = 2 * (L + W) * H;
    return {
      floor: floor,
      wall: wall,
      treatment: wall * (a.coverage || 0.25),
      known: false
    };
  }

  /* --- Pack optimiser ------------------------------------------------------
     Products sold in more than one pack size must not be bought as the small
     pack alone. Composition is 2.16 m² at $360.80 and 12.96 m² at $1,816.30;
     naive rounding overcharges by over $1,000 on a large wall. Searches every
     combination that meets the target and returns the cheapest.            */
  function optimise(packs, target) {
    var sorted = packs.slice().sort(function (x, y) { return y.cov - x.cov; });
    var best = null;

    function walk(i, chosen, cost, cov) {
      if (cov >= target) {
        if (!best || cost < best.cost) best = { lines: chosen.slice(), cost: cost, cov: cov };
        return;
      }
      if (i >= sorted.length) return;
      var p = sorted[i];
      var maxN = Math.ceil((target - cov) / p.cov) + 1;
      for (var n = 0; n <= maxN; n++) {
        if (n) chosen.push({ pack: p, qty: n });
        walk(i + 1, chosen, cost + n * p.price, cov + n * p.cov);
        if (n) chosen.pop();
      }
    }
    walk(0, [], 0, 0);

    if (!best) {
      var p = sorted[sorted.length - 1];
      var n = Math.ceil(target / p.cov);
      best = { lines: [{ pack: p, qty: n }], cost: n * p.price, cov: n * p.cov };
    }
    best.lines = best.lines.filter(function (l) { return l.qty > 0; });
    best.overshoot = target > 0 ? (best.cov - target) / target : 0;
    return best;
  }

  /* --- Promotion ----------------------------------------------------------- */
  function promo(cfg, subtotalCents) {
    var step = Math.round((cfg.threshold || 300) * 100);
    var save = Math.round((cfg.saving || 35) * 100);
    if (!cfg.active || subtotalCents < step) {
      return { saving: 0, active: !!cfg.active, nextAt: step - (subtotalCents % step) };
    }
    return {
      saving: Math.floor(subtotalCents / step) * save,
      active: true,
      nextAt: step - (subtotalCents % step)
    };
  }

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* --- Component ----------------------------------------------------------- */
  if (customElements.get('bf-residential-quiz')) return;

  customElements.define('bf-residential-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      this.answers = { coverage: 0.25, height: 2.4, areaMode: 'dims' };
      this.index = -1;
      this.products = [];
      this.stage = this.querySelector('[data-stage]');
      this.bar = this.querySelector('[data-bar]');

      this.cfg = {};
      try {
        var node = this.querySelector('[data-config]');
        if (node) this.cfg = JSON.parse(node.textContent.trim() || '{}');
      } catch (e) { console.error('[bf-quiz] config did not parse', e); }

      if (!this.stage) return;

      this.loadProducts();
      try {
        this.render();
        track('quiz_view', { entry_route: document.referrer ? 'referral' : 'direct' });
      } catch (e) {
        console.error('[bf-quiz] render failed', e);
        track('quiz_error', { step: 'boot', error_code: 'render_failed' });
        this.stage.innerHTML = '<p>Sorry, this could not load. <a href="' +
          (this.cfg.contactUrl || '/pages/contact') + '">Get in touch</a> and we will help directly.</p>';
      }
    }

    /* Eligibility is collection membership, resolved at runtime. */
    loadProducts() {
      var self = this;
      var handle = this.cfg.collection || 'black-friday-2026';
      fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.products) throw new Error('collection not readable');
          self.products = d.products.filter(function (p) {
            return ATTRS[p.handle] && p.variants.some(function (v) { return v.available; });
          }).map(function (p) {
            var a = ATTRS[p.handle];
            var avail = p.variants.filter(function (v) { return v.available; });
            return {
              handle: p.handle, title: p.title, image: (p.images[0] || {}).src,
              variants: avail, options: p.options,
              price: Math.round(parseFloat(avail[0].price) * 100),
              cov: a.cov, units: a.units, noun: a.noun, look: a.look,
              role: a.role, group: a.group, design: a.design || null, sp: a.sp
            };
          });
          if (self.showingResults) self.renderResults();
        })
        .catch(function (e) {
          console.error('[bf-quiz] could not load collection', e);
          track('quiz_error', { step: 'collection', error_code: 'collection_unavailable' });
          self.products = [];
          self.productsFailed = true;
          if (self.showingResults) self.renderResults();
        });
    }

    visible() {
      var a = this.answers;
      return QUESTIONS.filter(function (q) { return !q.showIf || q.showIf(a); });
    }

    go(step) {
      var list = this.visible();
      var next = this.index + step;
      if (next < 0) { this.index = -1; return this.render(); }
      if (next >= list.length) return this.finish();
      this.index = next;
      this.render();
      this.keepInView();
    }

    keepInView() {
      if (!this.getBoundingClientRect) return;
      var offset = parseInt(getComputedStyle(this).scrollMarginTop || '0', 10) || 0;
      if (this.getBoundingClientRect().top < offset) {
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    render() {
      if (this.index === -1) return this.renderWelcome();
      var list = this.visible();
      var q = list[this.index];
      if (!q) return this.finish();

      this.bar.parentElement.hidden = false;
      this.bar.style.width = (this.index / list.length * 100) + '%';
      track('quiz_step_view', { question_id: q.id, step: this.index + 1 });

      var h = '<div class="bf-q"><h2 class="bf-q__title">' + q.title + '</h2>';
      if (q.help) h += '<p class="bf-q__help">' + q.help + '</p>';

      if (q.type === 'single') {
        h += '<div class="bf-opts">';
        q.options.forEach(function (o, i) {
          var sel = this.answers[q.id] === o.v;
          h += '<button type="button" class="bf-opt" data-i="' + i + '" aria-pressed="' + !!sel + '"><span>' +
               o.label + '</span></button>';
        }, this);
        h += '</div>';
      } else if (q.type === 'dims') {
        if (this.answers.areaMode === 'known') {
          h += '<div class="bf-dims"><label>Panel area<input type="number" inputmode="decimal" min="1" max="500" step="0.1" data-f="panelArea" value="' +
               (this.answers.panelArea || '') + '"><span>m²</span></label></div>' +
               '<p class="bf-warn" data-warn hidden></p>' +
               '<button type="button" class="bf-link" data-mode="dims">Give room dimensions instead</button>';
        } else {
          h += '<div class="bf-dims">' +
               '<label>Length<input type="number" inputmode="decimal" min="1" max="30" step="0.1" data-f="length" value="' + (this.answers.length || '') + '"><span>m</span></label>' +
               '<label>Width<input type="number" inputmode="decimal" min="1" max="30" step="0.1" data-f="width" value="' + (this.answers.width || '') + '"><span>m</span></label>' +
               '</div><p class="bf-warn" data-warn hidden></p>' +
               '<button type="button" class="bf-link" data-mode="known">I already know the panel area I need</button>';
        }
      }

      h += '<div class="bf-nav"><button type="button" class="bf-back" data-back>Back</button>';
      if (q.type === 'dims') h += '<button type="button" class="bf-next" data-next>Continue</button>';
      h += '</div></div>';

      this.stage.innerHTML = h;
      this.wire(q);
      var first = this.stage.querySelector('.bf-opt, input');
      if (first) first.focus({ preventScroll: true });
    }

    wire(q) {
      var self = this;

      this.stage.querySelectorAll('.bf-opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var o = q.options[+btn.dataset.i];
          self.answers[q.id] = o.v;
          track('quiz_answer', { question_id: q.id, answer_code: String(o.v) });
          if (o.interstitial && !self.answers.transferAck) return self.renderInterstitial();
          self.go(1);
        });
      });

      this.stage.querySelectorAll('[data-f]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var v = parseFloat(inp.value);
          var warn = self.stage.querySelector('[data-warn]');
          var max = +inp.getAttribute('max'), min = +inp.getAttribute('min');
          var msg = '';
          if (isFinite(v) && v > 0) {
            if (v > max && v / 1000 >= min && v / 1000 <= max) {
              msg = 'That looks like millimetres. Did you mean ' + (v / 1000) + ' m?';
            } else if (v > max) {
              msg = 'That is larger than we can size from here. Tell us about the room and we will work it out with you.';
            } else if (v < min) {
              msg = 'That needs to be at least ' + min + '.';
            }
          }
          if (warn) { warn.textContent = msg; warn.hidden = !msg; }
          self.answers[inp.dataset.f] = (isFinite(v) && v >= min && v <= max) ? v : null;
        });
      });

      var mode = this.stage.querySelector('[data-mode]');
      if (mode) mode.addEventListener('click', function () {
        self.answers.areaMode = mode.dataset.mode;
        self.answers.length = self.answers.width = self.answers.panelArea = null;
        self.render();
      });

      var back = this.stage.querySelector('[data-back]');
      if (back) back.addEventListener('click', function () { self.go(-1); });

      var next = this.stage.querySelector('[data-next]');
      if (next) next.addEventListener('click', function () {
        var a = self.answers;
        var ok = a.areaMode === 'known' ? !!a.panelArea : (!!a.length && !!a.width);
        if (!ok) {
          track('quiz_error', { step: 'size', error_code: 'missing_dimensions' });
          var warn = self.stage.querySelector('[data-warn]');
          if (warn) { warn.textContent = 'Pop a number in so we can work out the quantities.'; warn.hidden = false; }
          return;
        }
        track('quiz_answer', {
          question_id: 'size',
          answer_code: a.areaMode,
          room_size_band: sizeBand(a.areaMode === 'known' ? a.panelArea : a.length * a.width)
        });
        self.go(1);
      });
    }

    renderWelcome() {
      this.bar.parentElement.hidden = true;
      var c = this.cfg;
      var img = c.image ? '<div class="bf-hero__img"><img src="' + c.image + '" alt="' +
        String(c.imageAlt || '').replace(/"/g, '&quot;') + '"></div>' : '';
      this.stage.innerHTML =
        '<div class="bf-hero">' + img +
          '<div class="bf-hero__body">' +
            (c.saleBadge ? '<span class="bf-badge">' + c.saleBadge + '</span>' : '') +
            '<h2 class="bf-hero__title">' + (c.heading || 'Work out exactly what your room needs') + '</h2>' +
            '<p class="bf-hero__text">' + (c.intro || "Answer six quick questions and we'll tell you which panels suit your room and how many packs to buy. No guesswork, no quotes, no waiting.") + '</p>' +
            '<div class="bf-hero__cta"><button type="button" class="bf-cta" data-start>Start now</button>' +
            '<a class="bf-link" href="/collections/' + (c.collection || 'black-friday-2026') + '">Shop the sale instead</a></div>' +
            '<p class="bf-hero__time">Takes about 90 seconds</p>' +
          '</div>' +
        '</div>';
      var self = this;
      this.stage.querySelector('[data-start]').addEventListener('click', function () {
        newAttempt();
        track('quiz_start', {});
        self.go(1);
      });
    }

    /* Noise transfer: an interstitial, never a dead end. */
    renderInterstitial() {
      var self = this;
      this.bar.parentElement.hidden = true;
      this.stage.innerHTML =
        '<div class="bf-caveat">' +
          '<h2>Worth knowing before you spend anything</h2>' +
          "<p>Panels absorb sound that is already in the room. They don't block sound coming through a wall, a window or a floor. If the problem is the neighbours, traffic or the room upstairs, panels will change how your room sounds but they won't meaningfully reduce what you hear from next door, and we would rather say so now.</p>" +
          '<p>Most rooms with a noise problem are also echoey, and treating that genuinely makes the space more comfortable to be in. If that is useful, keep going.</p>' +
          '<div class="bf-nav">' +
            '<button type="button" class="bf-cta" data-continue>Keep going, the room is echoey too</button>' +
            '<a class="bf-link" href="' + (this.cfg.contactUrl || '/pages/contact') + '">Talk to us instead</a>' +
          '</div>' +
        '</div>';
      track('quiz_step_view', { question_id: 'transfer_interstitial', step: 2 });
      this.stage.querySelector('[data-continue]').addEventListener('click', function () {
        self.answers.transferAck = true;
        track('quiz_answer', { question_id: 'transfer_interstitial', answer_code: 'continue' });
        self.go(1);
      });
    }

    /* --- Recommendation ---------------------------------------------------- */
    recommend() {
      var a = this.answers;
      var pool = this.products.slice();
      if (!pool.length) return null;

      /* Feature pieces only when asked for. Buying fourteen 0.64 m² panels to
         cover a wall is not a recommendation. */
      if (a.look !== 'feature') {
        pool = pool.filter(function (p) { return p.role !== 'feature'; });
      }
      if (!pool.length) return null;

      pool.forEach(function (p) {
        p._s = (a.look !== 'any' && p.look === a.look ? 3 : 0) +
               (p.sp.indexOf(a.room) > -1 ? 2 : 0);
      });

      /* One entry per product group: the four QuietForm designs are identical
         in coverage and price, so they collapse to one card with a picker. */
      var byGroup = {};
      pool.forEach(function (p) {
        var g = byGroup[p.group];
        if (!g) { byGroup[p.group] = { score: p._s, items: [p] }; return; }
        g.items.push(p);
        if (p._s > g.score) g.score = p._s;
      });

      var groups = Object.keys(byGroup).map(function (k) {
        var g = byGroup[k];
        /* Within a group, the cheapest per m² leads; other pack sizes feed the
           optimiser rather than competing as separate recommendations. */
        g.items.sort(function (x, y) { return (x.price / x.cov) - (y.price / y.cov); });
        g.key = k;
        g.lead = g.items[0];
        g.perM2 = g.lead.price / g.lead.cov;
        return g;
      });

      groups.sort(function (x, y) { return y.score - x.score || x.perM2 - y.perM2; });
      return groups;
    }

    quoteFor(group, target) {
      var packs = group.items.map(function (p) {
        return { handle: p.handle, title: p.title, cov: p.cov, units: p.units,
                 noun: p.noun, price: p.price, product: p };
      });
      return optimise(packs, target);
    }

    finish() {
      this.showingResults = true;
      this.bar.parentElement.hidden = true;
      this.renderResults();
    }

    renderResults() {
      var a = this.answers, self = this;
      var A = areas(a);
      var target = A.treatment;

      if (!this.products.length) {
        if (!this.productsFailed) {
          /* Still fetching. renderResults runs again when it lands. */
          this.stage.innerHTML = '<p class="bf-loading">Working out your quantities…</p>';
          return;
        }
        this.stage.innerHTML =
          '<div class="bf-caveat"><h2>Let us work this one out with you</h2>' +
          '<p>We could not load the sale range just now. Tell us about the room and we will come back with a recommendation and a quantity.</p>' +
          '<a class="bf-cta" href="' + (this.cfg.contactUrl || '/pages/contact') + '">Tell us about your room</a></div>';
        track('quiz_error', { step: 'results', error_code: 'no_products' });
        return;
      }

      var groups = this.recommend();
      if (!groups || !groups.length || !target) {
        this.stage.innerHTML =
          '<div class="bf-caveat"><h2>Let us work this one out with you</h2>' +
          '<p>Nothing in the sale range is a clean fit for what you have described. Rather than guess, tell us about the room and we will give you a straight answer.</p>' +
          '<a class="bf-cta" href="' + (this.cfg.contactUrl || '/pages/contact') + '">Tell us about your room</a></div>';
        track('quiz_error', { step: 'results', error_code: 'no_match' });
        return;
      }

      var primary = groups[0];
      var alts = groups.slice(1, 3);
      var quote = this.quoteFor(primary, target);

      var h = '<div class="bf-result">';

      /* 1. Summary */
      h += '<div class="bf-sec"><span class="bf-eyebrow">Your room</span>' +
           '<h2>' + (ROOM_LABEL[a.room] || 'room').replace(/^./, function (c) { return c.toUpperCase(); }) +
           ', ' + COVER_LABEL(a.coverage).toLowerCase() + ' treatment</h2>' +
           '<p>' + (A.known
             ? 'You told us you need ' + target.toFixed(1) + ' m² of panelling, so we have used that exactly as given.'
             : 'Your walls total about ' + A.wall.toFixed(0) + ' m². At ' + Math.round(a.coverage * 100) +
               '% coverage that is <b>' + target.toFixed(1) + ' m² of panelling</b>.') + '</p></div>';

      /* 2. Coverage control */
      h += '<div class="bf-cover"><span class="bf-cover__label">Change the coverage</span><div class="bf-cover__opts">';
      [0.20, 0.25, 0.50].forEach(function (r) {
        var t = A.known ? target : A.wall * r;
        h += '<button type="button" class="bf-cover__btn" data-cov="' + r + '" aria-pressed="' +
             (a.coverage === r) + '"><strong>' + COVER_LABEL(r) + '</strong><span>' +
             Math.round(r * 100) + '% · ' + t.toFixed(1) + ' m²</span></button>';
      });
      h += '</div></div>';

      if (a.goal === 'transfer') {
        h += '<div class="bf-caveat bf-caveat--inline"><p>As we mentioned, this will change how the room itself sounds. It will not stop noise coming through the wall from next door.</p></div>';
      }

      /* 3. Primary recommendation */
      h += this.card(primary, quote, target, true);

      /* 4. Alternatives */
      if (alts.length) {
        h += '<div class="bf-sec"><span class="bf-eyebrow">Alternatives</span><h2>These would also work</h2></div><div class="bf-alts">';
        alts.forEach(function (g) {
          var q = self.quoteFor(g, target);
          h += self.card(g, q, target, false);
        });
        h += '</div>';
      }

      /* 5. Totals */
      var pr = promo(this.cfg.promo || {}, quote.cost);
      h += '<div class="bf-totals">' +
             '<div class="bf-totals__row"><span>Merchandise subtotal</span><strong>' + money(quote.cost) + '</strong></div>';
      if (pr.active && pr.saving) {
        h += '<div class="bf-totals__row bf-totals__row--save"><span>Black Friday saving</span><strong>− ' + money(pr.saving) + '</strong></div>' +
             '<div class="bf-totals__row bf-totals__row--total"><span>Total</span><strong>' + money(quote.cost - pr.saving) + '</strong></div>';
      } else if (pr.active) {
        h += '<div class="bf-totals__note">Spend ' + money(pr.nextAt) + ' more to unlock the first ' +
             money(Math.round((this.cfg.promo.saving || 35) * 100)) + ' saving.</div>';
      } else if (this.cfg.promo && this.cfg.promo.startsText) {
        h += '<div class="bf-totals__note">' + this.cfg.promo.startsText + '</div>';
      }
      h += '<div class="bf-totals__note">Shipping is calculated at checkout and is not included above.</div></div>';

      /* 6-9. Actions */
      h += '<div class="bf-actions">' +
             '<button type="button" class="bf-link" data-edit>Change my answers</button>' +
             '<a class="bf-link" href="' + (this.cfg.contactUrl || '/pages/contact') + '">Ask us a question</a>' +
           '</div>';

      h += '<p class="bf-fine">These quantities are an estimate based on the measurements you gave us. They are not a guaranteed acoustic result or a substitute for a proper assessment.</p>';
      h += '</div>';

      this.stage.innerHTML = h;
      this.wireResults(groups, target);

      track('quiz_results_view', {
        room_type: a.room,
        goal: a.goal,
        coverage_level: COVER_LABEL(a.coverage).toLowerCase(),
        treatment_area_m2: Math.round(target * 10) / 10,
        room_size_band: sizeBand(A.known ? target : A.floor),
        recommended_products: groups.slice(0, 3).map(function (g) { return g.lead.handle; }).join(','),
        recommended_value: Math.round(quote.cost) / 100
      });
    }

    card(group, quote, target, isPrimary) {
      var p = group.lead;
      var a = this.answers;
      var h = '<article class="bf-card' + (isPrimary ? ' bf-card--primary' : '') + '" data-group="' + group.key + '">';
      h += '<div class="bf-card__img">' + (p.image ? '<img src="' + p.image + '&width=700" alt="' + p.title.replace(/"/g, '') + '" loading="lazy">' : '') + '</div>';
      h += '<div class="bf-card__body"><h3 class="bf-card__title">' +
           (GROUP_LABEL[group.key] || p.title) + '</h3>';

      if (isPrimary) {
        h += '<p class="bf-card__why">' + (WHY[p.look] || '') + (ROOM_WHY[a.room] ? ' ' + ROOM_WHY[a.room] : '') + '</p>';
      }

      /* Packs to buy and units supplied, stated separately. */
      var totalUnits = 0, lineText = [];
      quote.lines.forEach(function (l) {
        totalUnits += l.qty * l.pack.units;
        lineText.push(l.qty + ' × ' + l.pack.units + '-' + l.pack.noun.replace(/s$/, '') +
                      ' pack <span class="bf-qty__each">' + money(l.pack.price) + ' each</span>');
      });

      h += '<div class="bf-qty">' +
             '<div><span class="bf-qty__label">Packs to buy</span><strong>' + lineText.join('<br>') + '</strong></div>' +
             '<div><span class="bf-qty__label">' + p.noun.replace(/^./, function (c) { return c.toUpperCase(); }) + ' supplied</span><strong>' + totalUnits + '</strong></div>' +
             '<div><span class="bf-qty__label">Covers</span><strong>' + quote.cov.toFixed(1) + ' m²</strong><span>against ' + target.toFixed(1) + ' m² needed</span></div>' +
             '<div><span class="bf-qty__label">Price for this quantity</span><strong>' + money(quote.cost) + '</strong></div>' +
           '</div>';

      if (quote.overshoot > 0.15) {
        h += '<p class="bf-note">This is the closest pack size, so it covers a bit more than you need.</p>';
      }

      /* Design picker for groups whose items are separate products. */
      if (group.items.length > 1 && group.items[0].design) {
        h += '<div class="bf-picker"><span class="bf-qty__label">Choose a design</span><div class="bf-picker__opts">';
        group.items.forEach(function (it, i) {
          h += '<button type="button" class="bf-chip" data-design="' + it.handle + '" aria-pressed="' + (i === 0) + '">' + (it.design || it.title) + '</button>';
        });
        h += '</div></div>';
      }

      /* Colour and variant are chosen on the product page, not here. The card
         states what to buy; the product page is where they see the swatches. */
      if (quote.lines.some(function (l) { return l.pack.product.variants.length > 1; })) {
        h += '<p class="bf-note">Colours and options are shown on the product page.</p>';
      }

      /* One button per pack the optimiser actually chose. The lead product is
         the cheapest per m², which is not always the pack being bought, so
         linking to the lead would send them to the wrong page. */
      h += '<div class="bf-card__actions">';
      quote.lines.forEach(function (l, i) {
        var multi = quote.lines.length > 1;
        h += '<a class="bf-cta' + (isPrimary && i === 0 ? '' : ' bf-cta--ghost') +
             '" href="/products/' + l.pack.product.handle + '" data-view="' + l.pack.product.handle + '">' +
             (multi ? 'View ' + l.pack.units + '-' + l.pack.noun.replace(/s$/, '') + ' pack' : 'View product') +
             '</a>';
      });
      h += '</div></div></article>';
      return h;
    }

    wireResults(groups, target) {
      var self = this;

      this.stage.querySelectorAll('[data-cov]').forEach(function (b) {
        b.addEventListener('click', function () {
          self.answers.coverage = parseFloat(b.dataset.cov);
          track('quiz_answer', { question_id: 'coverage', answer_code: b.dataset.cov });
          self.renderResults();
        });
      });

      /* The product page is now where the funnel continues, so this click is
         the quiz's exit event. Carry the quantity and value it was sized at. */
      this.stage.querySelectorAll('[data-view]').forEach(function (link, i) {
        link.addEventListener('click', function () {
          var card = link.closest('[data-group]');
          var g = card ? groups.filter(function (x) { return x.key === card.dataset.group; })[0] : null;
          var q = g ? self.quoteFor(g, target) : null;
          track('quiz_product_click', {
            product_handle: link.dataset.view,
            position: i + 1,
            recommended_packs: q ? q.lines.reduce(function (n, l) { return n + l.qty; }, 0) : null,
            recommended_value: q ? Math.round(q.cost) / 100 : null
          });
        });
      });

      var edit = this.stage.querySelector('[data-edit]');
      if (edit) edit.addEventListener('click', function () {
        self.showingResults = false;
        self.index = 0;
        self.render();
      });

    }
  });
})();